/**
 * Old links to the app looked like `https://gibs.finance/#/bridge/1/native/369`.
 * The front page now lives at that address, and a server never sees a
 * fragment, so the page itself sends such a reader on to the app.
 */
import { LATEST_APP_ORIGIN } from './config'

/** The part of `window.location` this check reads and writes. */
export interface RedirectableLocation {
  readonly hash: string
  replace: (url: string) => void
}

/**
 * The app address for a hash route, or `null` when the hash is not one.
 * Only `#/` starts a route. A bare `#`, `#section` or an empty hash stays on this page.
 *
 * @param hash - `location.hash`, including the leading `#`
 * @returns the address on the stable app origin with the same hash
 */
export const buildAppUrlForHash = (hash: string): string | null =>
  hash.startsWith('#/') ? `${LATEST_APP_ORIGIN}/${hash}` : null

/**
 * Sends the browser to the app when the page was opened with a hash route.
 * Uses `replace`, so the Back button does not return to a page that redirects again.
 *
 * @param location - the browser location
 * @returns whether the browser is leaving this page
 */
export const redirectLegacyHashRoute = (location: RedirectableLocation): boolean => {
  const target = buildAppUrlForHash(location.hash)
  if (target === null) return false
  location.replace(target)
  return true
}
